import { useEffect, useState } from "react";

export function usePageMeta(title: string, description: string, keywords?: string) {
  useEffect(() => {
    document.title = title;

    const ensureMeta = (name: string, content: string, attr: "name" | "property" = "name") => {
      let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    ensureMeta("description", description);
    if (keywords) ensureMeta("keywords", keywords);
    ensureMeta("og:title", title, "property");
    ensureMeta("og:description", description, "property");
    ensureMeta("twitter:title", title);
    ensureMeta("twitter:description", description);
  }, [title, description, keywords]);
}

export function useScrollTop(dep: unknown) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [dep]);
}

export function useToast() {
  const [toast, setToast] = useState<string>("");

  const showToast = (message: string) => {
    setToast(message);
  };

  useEffect(() => {
    if (!toast) return undefined;
    const timer = window.setTimeout(() => setToast(""), 2600);
    return () => window.clearTimeout(timer);
  }, [toast]);

  return { toast, showToast, closeToast: () => setToast("") };
}